import { render } from "./payment-gateway-settings.vue?vue&type=template&id=7036b0f9"
import script from "./payment-gateway-settings.vue?vue&type=script&lang=js"
export * from "./payment-gateway-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__